import React from 'react';

import AngleOffset from './AngleOffset';
import Compass from './Compass';
import { DataCell, Heading, InfoColCell, InfoRowCell, Table, WindPanel } from './HarbourDial.style';
import getObsData from './utils/getObsData';

interface WindDirectionPanelProps {
    data: ReturnType<typeof getObsData>;
    runwayAngle: number;
}

const getAngleDifference = (alpha: number, beta: number) => {
    const phi = Math.abs(beta - alpha) % 360;

    let diff = phi > 180 ? 360 - phi : phi;
    diff = diff > 90 ? 180 - diff : diff;

    const sign = (alpha - beta >= 0 && alpha - beta <= 180) || (alpha - beta <= -180 && alpha - beta >= -360) ? -1 : 1;

    return diff * sign;
};

const WindDirectionPanel: React.FC<WindDirectionPanelProps> = ({ data, runwayAngle }) => (
    <WindPanel>
        <Heading>Wind direction (°)</Heading>

        <Compass angle={data.PT1M.windDirection.avg} minAngle={data.PT1M.windDirection.min} maxAngle={data.PT1M.windDirection.max} runwayAngle={runwayAngle} />

        {typeof runwayAngle === 'number' && typeof data.PT1M.windDirection.avg === 'number' && (
            <AngleOffset angle={getAngleDifference(runwayAngle, data.PT1M.windDirection.avg)} />
        )}

        <Table>
            <tbody>
                <tr>
                    <td />
                    <InfoColCell>1min</InfoColCell>
                    <InfoColCell>10min</InfoColCell>
                    <InfoColCell>60min</InfoColCell>
                </tr>
                <tr>
                    <InfoRowCell>Avg</InfoRowCell>
                    <DataCell>{data.PT1M.windDirection.avg}</DataCell>
                    <DataCell>{data.PT10M.windDirection.avg}</DataCell>
                    <DataCell>{data.PT1H.windDirection.avg}</DataCell>
                </tr>
                <tr>
                    <InfoRowCell>CW</InfoRowCell>
                    <DataCell>{data.PT1M.windDirection.max}</DataCell>
                    <DataCell>{data.PT10M.windDirection.max}</DataCell>
                    <DataCell>{data.PT1H.windDirection.max}</DataCell>
                </tr>
                <tr>
                    <InfoRowCell>CCW</InfoRowCell>
                    <DataCell>{data.PT1M.windDirection.min}</DataCell>
                    <DataCell>{data.PT10M.windDirection.min}</DataCell>
                    <DataCell>{data.PT1H.windDirection.min}</DataCell>
                </tr>
            </tbody>
        </Table>
    </WindPanel>
);

export default WindDirectionPanel;
